<template>
    <div>
        <logout-window
                :visible="logoutWindowVisible"
                @close-window="closeLogoutWindow"
        />
        <ul class="admin-menu">
            <li>
                <router-link :to="{name: 'Cabinet'}" :class="{active: $route.name == 'Cabinet'}">Мои карты</router-link>
            </li>
            <li>
                <router-link :to="{name: 'Profile'}" :class="{active: $route.name == 'Profile'}">Профиль</router-link>
            </li>
            <li v-if="userIsSuper">
                <router-link :to="{name: 'SuperUserList'}" :class="{active: $route.name == 'SuperUserList'}">
                    База клиентов
                </router-link>
            </li>
            <template v-if="userIsAdmin">
                <li>
                    <router-link :to="{name: 'AdminArticleList'}"
                                 :class="{active: $route.name == 'AdminArticleList' || $route.name == 'AdminArticleEdit'}">
                        Статьи
                    </router-link>
                </li>
                <li>
                    <router-link :to="{name: 'AdminPromocode'}" :class="{active: $route.name == 'AdminPromocode'}">
                        Промокод
                    </router-link>
                </li>
            </template>
            <li><a href="#" class="exit-link"
                   @click.prevent="showLogoutWindow">Выход</a></li>
        </ul>
    </div>
</template>

<script>
    import LogoutWindow from '@/components/window/LogoutWindow';

    export default {
        name: 'UserMenu',

        components: {
            LogoutWindow
        },

        data() {
            return {
                logoutWindowVisible: false
            }
        },

        computed: {
            userIsSuper() {
                const roleCode = this.$store.getters.currentUser.role;
                return roleCode === 'ROLE_SUPER';
            },

            userIsAdmin() {
                const roleCode = this.$store.getters.currentUser.role;
                return ['ROLE_ADMIN', 'ROLE_SUPER'].includes(roleCode);
            }
        },

        methods: {
            showLogoutWindow() {
                this.logoutWindowVisible = true;
            },

            closeLogoutWindow() {
                this.logoutWindowVisible = false;
            }
        }
    }
</script>
